import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Language } from '../../entities/control-tables/language-entity';

 

export class LanguageRequest extends BaseRequest {

    languageE : Language

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.languageE = new Language()
  }
}